(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentCopyDialogController', ShipmentCopyDialogController);

    ShipmentCopyDialogController.$inject = ['entity', 'Shipment', 'ToastrService', '$uibModalInstance', 'ContractCustomService', 'ShipmentCustomService', '$rootScope', '$timeout'];

    function ShipmentCopyDialogController(entity, Shipment, ToastrService, $uibModalInstance, ContractCustomService, ShipmentCustomService, $rootScope, $timeout) {
        var vm = this;

        vm.entity = entity;
        vm.shipment = undefined;
        vm.originalShipmentNumber = undefined;
        vm.originalShipment = undefined;

        vm.clear = clear;
        vm.save = save;
        vm.loadFullShipment = loadFullShipment;

        vm.showContractB = false;
        vm.showContractC = false;
        vm.showContractD = false;
        vm.showContractE = false;
        vm.disableAddPurchaseContract = true;
        vm.showAddPurchaseContract = false;
        vm.showValidationError = false;
        vm.showValidationErrorConstraint = false;

        vm.purchaseContractAList = [];
        vm.purchaseContractBList = [];
        vm.purchaseContractCList = [];
        vm.purchaseContractDList = [];
        vm.purchaseContractEList = [];
        vm.saleContractList = [];

        vm.refreshContractList = refreshContractList;
        vm.fetchPurchaseContractListByType = fetchPurchaseContractListByType;
        vm.checkContracts = checkContracts;
        vm.onTextClick = onTextClick;
        vm.computeShipmentQty = computeShipmentQty;
        vm.autoContractQtyDisplayAs = autoContractQtyDisplayAs;
        vm.addAnotherPurchaseContract = addAnotherPurchaseContract;
        vm.updateQtyDisplay = updateQtyDisplay;
        vm.removePurchaseContract = removePurchaseContract;
        vm.applyQtyUnitType = applyQtyUnitType;


        loadFullShipment();

        function removePurchaseContract(which) {
            switch (which) {
                case 'b':
                    if (vm.showContractC) {
                        if (null != vm.shipment.contractC) {
                            xferContractCtoContractB();
                        }
                        if(vm.showContractD) {
                            if(null != vm.shipment.contractD) {
                                xferContractDtoContractC()
                            }
                            if(vm.showContractE) {
                                if(null != vm.shipment.contractE) {
                                    xferContractEtoContractD();
                                }
                                resetContractE();
                            } else {
                                resetContractD();
                            }
                        } else {
                            resetContractC();
                        }
                    } else {
                        resetContractB();
                    }
                    break;
                case 'c':
                    if(vm.showContractD) {
                        if(null != vm.shipment.contractD) {
                            xferContractDtoContractC();
                        }
                        if(vm.showContractE) {
                            if(null != vm.shipment.contractE) {
                                xferContractEtoContractD();
                            }
                            resetContractE();
                        } else {
                            resetContractD();
                        }
                    } else {
                        resetContractC();
                    }
                    break;
                case 'd':
                    if(vm.showContractE) {
                        if(null != vm.shipment.contractE) {
                            xferContractEtoContractD();
                        }
                        resetContractE();
                    } else {
                        resetContractD();
                    }
                    break;
                case 'e':
                    resetContractE();
                    break;
            }
            checkContracts();
        }

        function resetContractB() {
            vm.shipment.contractB = null;
            vm.shipment.quantityContractB = 0;
            vm.shipment.qtyBalesContractB = 0;
            vm.shipment.qtyMtsContractB = 0;
            vm.shipment.qtyLbsContractB = 0;
            vm.shipment.qtyKgsContractB = 0;
            vm.shipment.qtyDisplayContractB = null;
            vm.showContractB = false;
            if (vm.shipment.contract !== null) {
                vm.disableAddPurchaseContract = false;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function resetContractC() {
            vm.shipment.contractC = null;
            vm.shipment.quantityContractC = 0;
            vm.shipment.qtyBalesContractC = 0;
            vm.shipment.qtyMtsContractC = 0;
            vm.shipment.qtyLbsContractC = 0;
            vm.shipment.qtyKgsContractC = 0;
            vm.shipment.qtyDisplayContractC = null;
            vm.showContractC = false;
            if (vm.shipment.contractB !== null) {
                vm.disableAddPurchaseContract = false;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function resetContractD() {
            vm.shipment.contractD = null;
            vm.shipment.quantityContractD = 0;
            vm.shipment.qtyBalesContractD = 0;
            vm.shipment.qtyMtsContractD = 0;
            vm.shipment.qtyLbsContractD = 0;
            vm.shipment.qtyKgsContractD = 0;
            vm.shipment.qtyDisplayContractD = null;
            vm.showContractD = false;
            if(vm.shipment.contractC !== null) {
                vm.disableAddPurchaseContract = false;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function resetContractE() {
            vm.shipment.contractE = null;
            vm.shipment.quantityContractE = 0;
            vm.shipment.qtyBalesContractE = 0;
            vm.shipment.qtyMtsContractE = 0;
            vm.shipment.qtyLbsContractE = 0;
            vm.shipment.qtyKgsContractE = 0;
            vm.shipment.qtyDisplayContractE = null;
            vm.showContractE = false;
            if(vm.shipment.contractD !== null) {
                vm.disableAddPurchaseContract = false;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        function xferContractCtoContractB() {
            vm.shipment.contractB = vm.shipment.contractC;
            vm.shipment.quantityContractB = vm.shipment.quantityContractC;
            vm.shipment.qtyBalesContractB = vm.shipment.qtyBalesContractC;
            vm.shipment.qtyMtsContractB = vm.shipment.qtyMtsContractC;
            vm.shipment.qtyLbsContractB = vm.shipment.qtyLbsContractC;
            vm.shipment.qtyKgsContractB = vm.shipment.qtyKgsContractC;
            vm.shipment.qtyDisplayContractB = vm.shipment.qtyDisplayContractC;
        }

        function xferContractDtoContractC() {
            vm.shipment.contractC = vm.shipment.contractD;
            vm.shipment.quantityContractC = vm.shipment.quantityContractD;
            vm.shipment.qtyBalesContractC = vm.shipment.qtyBalesContractD;
            vm.shipment.qtyMtsContractC = vm.shipment.qtyMtsContractD;
            vm.shipment.qtyLbsContractC = vm.shipment.qtyLbsContractD;
            vm.shipment.qtyKgsContractC = vm.shipment.qtyKgsContractD;
            vm.shipment.qtyDisplayContractC = vm.shipment.qtyDisplayContractD;
        }

        function xferContractEtoContractD() {
            vm.shipment.contractD = vm.shipment.contractE;
            vm.shipment.quantityContractD = vm.shipment.quantityContractE;
            vm.shipment.qtyBalesContractD = vm.shipment.qtyBalesContractE;
            vm.shipment.qtyMtsContractD = vm.shipment.qtyMtsContractE;
            vm.shipment.qtyLbsContractD = vm.shipment.qtyLbsContractE;
            vm.shipment.qtyKgsContractD = vm.shipment.qtyKgsContractE;
            vm.shipment.qtyDisplayContractD = vm.shipment.qtyDisplayContractE;
        }

        function refreshContractList(which) {
            switch (which) {
                case 'a':
                    vm.fetchPurchaseContractListByType("PURCHASE", "a");
                    break;
                case 'b':
                    vm.fetchPurchaseContractListByType("PURCHASE", "b");
                    break;
                case 'c':
                    vm.fetchPurchaseContractListByType("PURCHASE", "c");
                    break;
                case 'd':
                    vm.fetchPurchaseContractListByType("PURCHASE", "d");
                    break;
                case 'e':
                    vm.fetchPurchaseContractListByType("PURCHASE", "e");
                    break;
                case 'sale':
                    vm.fetchPurchaseContractListByType("SALE");
                    break;
            }
        }

        function fetchPurchaseContractListByType(type, which) {
            switch (type) {
                case 'PURCHASE':
                    ContractCustomService.returnMinifiedContractsByType(type).then(function (data) {
                        switch (which) {
                            case 'a':
                                vm.purchaseContractAList = data.data;
                                if (vm.shipment.contractB !== null && vm.shipment.contractB !== undefined) {
                                    var index = vm.purchaseContractAList.map(function (contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractB.id);
                                    vm.purchaseContractAList.splice(index, 1);
                                }
                                if (vm.shipment.contractC !== null && vm.shipment.contractC !== undefined) {
                                    var index = vm.purchaseContractAList.map(function (contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractC.id);
                                    vm.purchaseContractAList.splice(index, 1);
                                }
                                if(vm.shipment.contractD !== null && vm.shipment.contractD !== undefined) {
                                    var index = vm.purchaseContractAList.map(function(contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractD.id);
                                    vm.purchaseContractAList.splice(index, 1);
                                }
                                if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined) {
                                    var index = vm.purchaseContractAList.map(function(contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractE.id);
                                    vm.purchaseContractAList.splice(index, 1);
                                }
                                if (vm.purchaseContractAList.length > 0) {
                                    // ToastrService.success("Fetched Purchase Contract List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract List is Empty", "Warning");
                                }
                                break;
                            case 'b':
                                vm.purchaseContractBList = data.data;
                                var index = vm.purchaseContractBList.map(function (contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contract.id);
                                vm.purchaseContractBList.splice(index, 1);
                                if (vm.shipment.contractC !== null && vm.shipment.contractC !== undefined) {
                                    var index = vm.purchaseContractBList.map(function (contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractC.id);
                                    vm.purchaseContractBList.splice(index, 1);
                                }
                                if(vm.shipment.contractD !== null && vm.shipment.contractD !== undefined) {
                                    var index = vm.purchaseContractBList.map(function(contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractD.id);
                                    vm.purchaseContractBList.splice(index, 1);
                                }
                                if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined) {
                                    var index = vm.purchaseContractBList.map(function(contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractE.id);
                                    vm.purchaseContractBList.splice(index, 1);
                                }
                                if (vm.purchaseContractBList.length > 0) {
                                    // ToastrService.success("Fetched Purchase Contract B List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract B List is Empty", "Warning");
                                }
                                break;
                            case 'c':
                                vm.purchaseContractCList = data.data;
                                var index = vm.purchaseContractCList.map(function (contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contract.id);
                                vm.purchaseContractCList.splice(index, 1);
                                index = vm.purchaseContractCList.map(function (contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractB.id);
                                vm.purchaseContractCList.splice(index, 1);
                                if(vm.shipment.contractD !== null && vm.shipment.contractD !== undefined) {
                                    var index = vm.purchaseContractCList.map(function(contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractD.id);
                                    vm.purchaseContractCList.splice(index, 1);
                                }
                                if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined) {
                                    var index = vm.purchaseContractCList.map(function(contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractE.id);
                                    vm.purchaseContractCList.splice(index, 1);
                                }
                                if (vm.purchaseContractCList.length > 0) {
                                    // ToastrService.success("Fetched Purchase Contract C List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract C List is Empty", "Warning");
                                    vm.showContractC = false;
                                }
                                break;
                            case 'd':
                                vm.purchaseContractDList = data.data;
                                var index = vm.purchaseContractDList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contract.id);
                                vm.purchaseContractDList.splice(index, 1);
                                var index = vm.purchaseContractDList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractB.id);
                                vm.purchaseContractDList.splice(index, 1);
                                var index = vm.purchaseContractDList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractC.id);
                                vm.purchaseContractDList.splice(index, 1);
                                if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined) {
                                    var index = vm.purchaseContractDList.map(function(contract) {
                                        return contract.id;
                                    }).indexOf(vm.shipment.contractE.id);
                                    vm.purchaseContractDList.splice(index, 1);
                                }
                                if(vm.purchaseContractDList.length > 0) {
                                    // ToastrService.success("Fetched Purchase Contract D List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract D List is empty", "Warning");
                                    vm.showContractD = false;
                                }
                                break;
                            case 'e':
                                vm.purchaseContractEList = data.data;
                                var index = vm.purchaseContractEList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contract.id);
                                vm.purchaseContractEList.splice(index, 1);
                                var index = vm.purchaseContractEList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractB.id);
                                vm.purchaseContractEList.splice(index, 1);
                                var index = vm.purchaseContractEList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractC.id);
                                vm.purchaseContractEList.splice(index, 1);
                                var index = vm.purchaseContractEList.map(function(contract) {
                                    return contract.id;
                                }).indexOf(vm.shipment.contractD.id);
                                vm.purchaseContractEList.splice(index, 1);
                                if(vm.purchaseContractEList.length > 0) {
                                    // ToastrService.success("Fetched Purchase Contract E List", "Success!");
                                } else {
                                    ToastrService.warning("Purchase Contract E List is empty", "Warning");
                                    vm.showContractE = false;
                                }
                                break;
                        }
                    }, function (error) {
                        if (error.status !== "404") {
                            ToastrService.error("Failed to fetch Purchase Contracts", "Error!");
                            console.log(error.status, error.statusText);
                        }
                    });
                    break;
                case 'SALE':
                    vm.saleContractList.length = 0;
                    ContractCustomService.returnMinifiedContractsByType(type).then(function (data) {
                        vm.saleContractList = data.data;
                        if (vm.saleContractList.length > 0) {
                            // ToastrService.success("Fetched Sale Contract List", "Success!");
                        } else {
                            ToastrService.warning("Sale Contract List is Empty", "Warning");
                        }
                    }, function (error) {
                        if (error.status !== "404") {
                            ToastrService.error("Failed to fetch Sale Contracts", "Error!");
                            console.log(error.status, error.statusText);
                        }
                    });
                    break;
            }
        }

        function checkContracts() {
            if (vm.shipment.contract && vm.shipment.contract !== null) {
                applyContractQtyToShipmentQtyIfZero();
                autoGenerateQtyDisplayAsIfNull();
                vm.disableAddPurchaseContract = false;
                if (!vm.showContractB && vm.shipment.contractB === null) {
                    vm.disableAddPurchaseContract = false;
                } else {
                    if (!vm.showContractC && vm.shipment.contractB !== null) {
                        vm.disableAddPurchaseContract = false;
                    } else {
                        if(!vm.showContractD && vm.shipment.contractC !== null) {
                            vm.disableAddPurchaseContract = false;
                        } else {
                            if(!vm.showContractE && vm.shipment.contractD !== null) {
                                vm.disableAddPurchaseContract = false;
                            } else {
                                vm.disableAddPurchaseContract = true;
                            }
                        }
                    }
                }
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            } else {
                vm.disableAddPurchaseContract = true;
            }
        }

        function applyContractQtyToShipmentQtyIfZero() {
            if (vm.shipment.contract !== null && vm.shipment.contract !== undefined && ( vm.shipment.quantityContractA === 0 || vm.shipment.quantityContractA === null ) ) {
                vm.shipment.quantityContractA = vm.shipment.contract.quantity;
            }
            if (vm.shipment.contractB !== null && vm.shipment.contractB !== undefined && ( vm.shipment.quantityContractB === 0 || vm.shipment.quantityContractB === null ) ) {
                vm.shipment.quantityContractB = vm.shipment.contractB.quantity;
            }
            if (vm.shipment.contractC !== null && vm.shipment.contractC !== undefined && ( vm.shipment.quantityContractC === 0 || vm.shipment.quantityContractC === null ) ) {
                vm.shipment.quantityContractC = vm.shipment.contractC.quantity;
            }
            if(vm.shipment.contractD !== null && vm.shipment.contractD !== undefined && ( vm.shipment.quantityContractD === 0 || vm.shipment.quantityContractD === null ) ) {
                vm.shipment.quantityContractD = vm.shipment.contractD.quantity;
            }
            if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined && ( vm.shipment.quantityContractE === 0 || vm.shipment.quantityContractE === null ) ) {
                vm.shipment.quantityContractE = vm.shipment.contractE.quantity;
            }
            if( vm.shipment.saleContract !== null && vm.shipment.saleContract !== undefined && ( vm.shipment.quantitySaleContract === 0 || vm.shipment.quantitySaleContract === null ) ) {
                vm.shipment.quantitySaleContract = vm.shipment.saleContract.quantity;
            }
            computeShipmentQty();
        }

        function autoGenerateQtyDisplayAsIfNull() {
            if (vm.shipment.contract !== null && vm.shipment.contract !== undefined && vm.shipment.qtyDisplayContractA === null ) {
                vm.shipment.qtyDisplayContractA = vm.shipment.quantityContractA + " " + vm.shipment.contract.qtyUnitType;
            }
            if (vm.shipment.contractB !== null && vm.shipment.contractB !== undefined && vm.shipment.qtyDisplayContractB === null ) {
                vm.shipment.qtyDisplayContractB = vm.shipment.quantityContractB + " " + vm.shipment.contractB.qtyUnitType;
            }
            if (vm.shipment.contractC !== null && vm.shipment.contractC !== undefined && vm.shipment.qtyDisplayContractC === null) {
                vm.shipment.qtyDisplayContractC = vm.shipment.quantityContractC + " " + vm.shipment.contractC.qtyUnitType;
            }
            if( vm.shipment.contractD !== null && vm.shipment.contractD !== undefined && vm.shipment.qtyDisplayContractD === null) {
                vm.shipment.qtyDisplayContractD = vm.shipment.quantityContractD + " " + vm.shipment.contractD.qtyUnitType;
            }
            if(vm.shipment.contractE !== null && vm.shipment.contractE !== undefined && vm.shipment.qtyDisplayContractE === null) {
                vm.shipment.qtyDisplayContractE = vm.shipment.quantityContractE + " " + vm.shipment.contractE.qtyUnitType;
            }
            if( vm.shipment.saleContract !== null && vm.shipment.saleContract !== undefined && vm.shipment.qtyDisplaySaleContract === null ) {
                vm.shipment.qtyDisplaySaleContract = vm.shipment.quantitySaleContract + " " + vm.shipment.saleContract.qtyUnitType;
            }
        }

        function onTextClick($event) {
            $event.target.select();
        }

        function computeShipmentQty() {
            if (isNaN(vm.shipment.quantityContractA)) {
                vm.shipment.quantityContractA = 0;
            }
            if (isNaN(vm.shipment.quantityContractB)) {
                vm.shipment.quantityContractB = 0;
            }
            if (isNaN(vm.shipment.quantityContractC)) {
                vm.shipment.quantityContractC = 0;
            }
            if( isNaN(vm.shipment.quantityContractD)) {
                vm.shipment.quantityContractD = 0;
            }
            if( isNaN(vm.shipment.quantityContractE)) {
                vm.shipment.quantityContractE = 0;
            }
            if( isNaN(vm.shipment.quantitySaleContract)) {
                vm.shipment.quantitySaleContract = 0;
            }
        }

        function autoContractQtyDisplayAs(which) {
            switch (which) {
                case 'a':
                    vm.shipment.qtyDisplayContractA = vm.shipment.quantityContractA + " " + vm.shipment.contract.qtyUnitType;
                    break;
                case 'b':
                    vm.shipment.qtyDisplayContractB = vm.shipment.quantityContractB + " " + vm.shipment.contractB.qtyUnitType;
                    break;
                case 'c':
                    vm.shipment.qtyDisplayContractC = vm.shipment.quantityContractC + " " + vm.shipment.contractC.qtyUnitType;
                    break;
                case 'd':
                    vm.shipment.qtyDisplayContractD = vm.shipment.quantityContractD + " " + vm.shipment.contractD.qtyUnitType;
                    break;
                case 'e':
                    vm.shipment.qtyDisplayContractE = vm.shipment.quantityContractE + " " + vm.shipment.contractE.qtyUnitType;
                    break;
                case 'sale':
                    vm.shipment.qtyDisplaySaleContract = vm.shipment.quantitySaleContract + " " + vm.shipment.saleContract.qtyUnitType;
                    break;
            }
        }

        function addAnotherPurchaseContract() {
            if(vm.showContractD) {
                fetchPurchaseContractListByType("PURCHASE", "e");
                vm.showContractE = true;
                vm.showAddPurchaseContract = false;
            } else if(vm.showContractC) {
                fetchPurchaseContractListByType("PURCHASE", "d");
                vm.showContractD = true;
                vm.disableAddPurchaseContract = true;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            } else if(vm.showContractB) {
                fetchPurchaseContractListByType("PURCHASE", "c");
                vm.showContractC = true;
                vm.disableAddPurchaseContract = true;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            } else {
                fetchPurchaseContractListByType("PURCHASE", "b");
                vm.showContractB = true;
                vm.disableAddPurchaseContract = true;
                vm.showAddPurchaseContract = !vm.disableAddPurchaseContract;
            }
        }

        //TODO -- do something about this
        function loadFullShipment() {
            Shipment.get({id: vm.entity.id}).$promise.then(function (data) {
                vm.shipment = data;
                console.log("shipment contract qty a: " + vm.shipment.quantityContractA);
                vm.originalShipmentNumber = angular.copy(vm.shipment.siNum);
                vm.originalShipment = data;
                vm.fetchPurchaseContractListByType("PURCHASE", "a");
                vm.fetchPurchaseContractListByType("SALE");
                if (vm.shipment.contractB !== undefined && vm.shipment.contractB !== null) {
                    vm.showContractB = true;
                    vm.fetchPurchaseContractListByType("PURCHASE", "b");
                }
                if (vm.shipment.contractC !== undefined && vm.shipment.contractC !== null) {
                    vm.showContractC = true;
                    vm.fetchPurchaseContractListByType("PURCHASE", "c");
                }
                if(vm.shipment.contractD !== undefined && vm.shipment.contractD !== null) {
                    vm.showContractD = true;
                    vm.fetchPurchaseContractListByType("PURCHASE", "d");
                }
                if(vm.shipment.contractE !== undefined && vm.shipment.contractE !== null) {
                    vm.showContractE = true;
                    vm.fetchPurchaseContractListByType("PURCHASE", "e");
                }
                vm.checkContracts();
                $timeout(function() {
                    autoGenerateQtyDisplayAsIfNull();
                    resolveShipmentQtyDisplay();
                }, 1000);
            }, function (error) {
                ToastrService.error("Failed to load contract", "Error!");
            });
        }

        function updateQtyDisplay() {
            vm.autoContractQtyDisplayAs('sale');
            vm.autoContractQtyDisplayAs('a');
            vm.autoContractQtyDisplayAs('b');
            vm.autoContractQtyDisplayAs('c');
            vm.autoContractQtyDisplayAs('d');
            vm.autoContractQtyDisplayAs('e');
        }

        function applyQtyUnitType( val ) {
            vm.shipment.qtyUnitType = val;
            resolveShipmentQtyDisplay();
        }

        function resolveShipmentQtyDisplay() {
            if( !vm.shipment.quantity || vm.shipment.quantity === null || vm.shipment.quantity.length === 0 ) {
                vm.shipment.quantity = 0;
            }
            vm.shipment.qtyDisplay = vm.shipment.quantity + " " + vm.shipment.qtyUnitType;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save(goToEdit) {
            if (validShipmentToSave()) {
                vm.isSaving = true;
                var shipmentToSave = angular.copy(vm.originalShipment);
                shipmentToSave.id = null;
                shipmentToSave.siNum = vm.shipment.siNum;
                if (vm.shipment.contract && vm.shipment.contract !== null) {
                    shipmentToSave.contract = {
                        id: vm.shipment.contract.id
                    };
                }
                if (vm.shipment.contractB && vm.shipment.contractB !== null) {
                    shipmentToSave.contractB = {
                        id: vm.shipment.contractB.id
                    };
                }
                if (vm.shipment.contractC && vm.shipment.contractC !== null) {
                    shipmentToSave.contractC = {
                        id: vm.shipment.contractC.id
                    };
                }
                if (vm.shipment.saleContract && vm.shipment.saleContract !== null) {
                    shipmentToSave.saleContract = {
                        id: vm.shipment.saleContract.id
                    };
                }

                Shipment.save(shipmentToSave, function (data) {
                    vm.isSaving = false;
                    if (goToEdit) {
                        $rootScope.$emit('handleEmit', {
                            heading: 'Edit ' + data.siNum,
                            route: 'shipment.edit',
                            id: data.id,
                            param: { id: '' }
                        });
                    }
                    $uibModalInstance.dismiss('ok');
                }, function (error) {
                    vm.isSaving = false;
                    ToastrService.error("Failed to copy shipment", "Error!");
                });
            }
        }

        function validShipmentToSave() {
            vm.showValidationError = false;
            vm.showValidationErrorConstraint = false;

            const validAllData =  vm.shipment.siNum && vm.shipment.siNum.length > 0
                && vm.shipment.contract && vm.shipment.contract.id > 0;
            const validConstraint = vm.originalShipmentNumber !== vm.shipment.siNum;

            if (!validConstraint) {
                vm.showValidationErrorConstraint = true;
            }
            if (!validAllData) {
                vm.showValidationError = true;
            }
            return validAllData && validConstraint;
        }
    }
})();
